import { ComboboxOption } from '@common/ui/Combobox/Combobox';
import { ResourceFilterType } from '@client-app-sdk';

export interface FormState {
  selectedIntegration: ComboboxOption | null;
  selectedResourceType: ComboboxOption | null;
  selectedPermission: ComboboxOption | null;
  selectedMultiplePermission: ComboboxOption[] | null;
  selectedResource: ComboboxOption[] | null;
  justification: string;
}

export const ensureArray = (input: string | string[]) => (Array.isArray(input) ? input : [input]);

export const createResourcesFilter = (input: ComboboxOption[]) => {
  const resourcesFilter = input.map((r) => {
    const [filterType, filterValue] = r.value.split(':');

    return {
      type: filterType === ResourceFilterType.Id ? ResourceFilterType.Id : ResourceFilterType.SearchTerm,
      value: filterValue,
    };
  });

  return resourcesFilter;
};
